import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { Subject } from 'rxjs';
import { CodedValueItem } from 'app/shared/interfaces/coded-value-item.interface';

@Component({
  selector: 'app-type-utilization-box',
  templateUrl: 'type-utilization-box.component.html',
  styleUrls: ['type-utilization-box.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: TypeUtilizationBoxComponent,
    },
  ],
  host: {
    '[class.state-disabled]': '!!disabled',
  },
})
export class TypeUtilizationBoxComponent
  implements OnInit, OnChanges, OnDestroy, ControlValueAccessor
{
  @Input()
  value: string;
  @Output()
  valueChange = new EventEmitter<string>();

  @Input()
  disabled: boolean;
  @Input()
  readOnly: boolean;

  private onChange = (value) => {};

  private onTouched = () => {};

  typeUtilizationList: CodedValueItem<string>[];
  typeUtilizationSet = new Set<string>();

  private lifecycle = new Subject<void>();

  ngOnInit(): void {
    this.typeUtilizationList = [
      {
        value: 'CAB',
        label: 'Acomodação de cablagem',
      },
      {
        value: 'EQU',
        label: 'Acomodaçao de equipamentos',
      },
      {
        value: 'JUN',
        label: 'Dispositivos de Junção/Derivação',
      },
      {
        value: 'TER',
        label: 'Terminações',
      },
    ];
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.value) {
      this.handleValue();
    }
  }

  ngOnDestroy(): void {
    this.lifecycle.next();
    this.lifecycle.complete();
  }

  writeValue(value: string): void {
    if (this.value !== value) {
      this.value = value;
      this.handleValue();
    }
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = !!isDisabled;
  }

  onTypeUtilizationChanged(item: CodedValueItem<string>, checked: boolean) {
    if (checked) {
      this.typeUtilizationSet.add(item.value);
    } else {
      this.typeUtilizationSet.delete(item.value);
    }

    const value = Array.from(this.typeUtilizationSet.values()).sort().join(',');

    if (this.value !== value) {
      this.value = value;
      this.valueChange.emit(this.value);

      this.onChange?.(this.value);
    }
  }

  private handleValue() {
    const list =
      this.value
        ?.split(',')
        ?.map((x) => x.trim())
        ?.filter((x) => !!x) ?? [];
    this.typeUtilizationSet = new Set(list);
  }
}
